<template lang="pug">
modal#edit-team-modal(
  :auxButtonLabel='$t("modal.editTeam.deleteButtonLabel")'
  :auxButtonShow='true'
  :loading='loading'
  :process-button-label='$t("modal.editTeam.processButtonLabel")'
  :showCancelButton='false'
  :title='$t("modal.editTeam.title")'
  @auxButtonAction='openDeleteTeamModal'
  @closed='onCloseModal'
  @opened='key += 1'
  @process='submit'
  ref='modal'
  size='sm'
)
  ValidationObserver(ref='form' v-slot='{ handleSubmit }')
    form(@submit.prevent='handleSubmit(submit)')

    ValidationProvider(
      name='nome'
      rules='required'
      v-slot='{ errors }'
    )
      .form-group(:key='key')
        label {{ $t('modal.editTeam.nameLabel') }}
        .form-control-icon
          icon(name='users')
          input.form-control(
            :class='{ "border border-danger": errors[0] }'
            :placeholder='$t("modal.editTeam.namePlaceholder")'
            autocomplete='off'
            type='text'
            v-model.trim='editableTeam.name'
          )
        small.text.text-danger {{ errors[0] }}
  delete-team-modal(
    :team='this.team'
    @closed='onDeleteTeamModalClosed'
    @item-deleted='onTeamDeleted'
    @refresh='onTeamDeleted'
    ref='deleteTeamModal'
  )
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import Icon from '@/ui/atoms/Icon.vue';
import TeamsService from '@/modules/account/services/http/TeamsService';
import DeleteTeamModal from '@/modules/account/components/organisms/modals/DeleteTeamModal.vue';

export default {
  name: 'EditTeamModal',
  components: {
    Modal,
    Icon,
    DeleteTeamModal,
  },
  props: {
    team: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      editableTeam: {
        name: '',
      },
      key: 1,
      reopenEditModal: true,
    };
  },
  watch: {
    team(newValue) {
      Object.assign(this.editableTeam, newValue);
    },
  },
  methods: {
    onCloseModal() {
      Object.assign(this.editableTeam, this.team);
    },
    async submit() {
      this.$loading(true);
      TeamsService.supressDefault = true;
      TeamsService.update(this.editableTeam.id, {
        name: this.editableTeam.name,
      })
        .then(() => {
          this.$refs.modal.close();
          this.$emit('refresh');
        })
        .finally(() => {
          TeamsService.supressDefault = false;
          this.$loading(false);
        });
    },
    openDeleteTeamModal() {
      this.reopenEditModal = true;
      this.selectedTeam = this.team;
      this.$refs.modal.close();
      setTimeout(() => {
        this.$refs.deleteTeamModal.$refs.modal.open();
      }, 350);
    },
    onTeamDeleted() {
      this.reopenEditModal = false;
      this.$refs.modal.close();
      this.$emit('item-deleted');
    },
    onDeleteTeamModalClosed() {
      if (this.reopenEditModal) {
        this.$refs.modal.open();
      }
    },
  },
};
</script>
